import axios from '@lib/axios';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

interface CreateSelectOptionProps {
  path: string;
	createData?: object;
	resourceName: string;
	onSuccess?: (res: AxiosResponse) => void;
  onError?: (res: AxiosResponse) => void;
}

export const useCreateSelectOption = ({
  path,
	createData = {},
	resourceName,
	onSuccess,
  onError
}: CreateSelectOptionProps) => {
	const queryClient = useQueryClient();
	const {
		mutate: onCreateSelectOption,
		...rest
	} = useMutation({
		mutationFn: async (name: string) => axios.post(path, { ...createData, name }),
		onSuccess: (res) => {
			queryClient.invalidateQueries({ queryKey: [resourceName, createData] });
			if (onSuccess)
				onSuccess(res);
		},
    onError
	});

	return { onCreateSelectOption, ...rest };
};
